import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import homeRouter from "./homeRouter";

const routes = [
  {
    path:'/',
    redirect: '/home'
  },
  {
    path: '/notLogin',
    component: () => import('../views/login/notLogin'),
    meta: {
      title: '主页',
      needLogin: false
    }
  },
  {
    path: '/expertDetail',
    component: () => import('../views/login/expertDetail'),
    meta: {
      title: '专家详情',
      needLogin: false
    }
  },
  {
    path: '/login',
    component: () => import('../views/login/login'),
    meta: {
      title: '登录',
      needLogin: false
    }
  },
  {
    path: '/help',
    component: () => import('../views/login/help'),
    meta: {
      title: '帮助中心',
      needLogin: false
    }
  },
  {
    path: '/version',
    component: () => import('../views/login/version'),
    meta: {
      title: '版本更新',
      needLogin: false
    }
  },
  // {
  //   path: '/register',
  //   component: () => import('../views/login/register'),
  //   meta: {
  //     title: '注册',
  //     needLogin: false
  //   }
  // },
  {
    path: '/findpass',
    component: () => import('../views/login/findpass'),
    meta: {
      title: '找回密码',
      needLogin: false
    }
  },
  {
    path: '/expert',
    component: () => import('../views/login/expert'),
    meta: {
      title: '专家列表',
      needLogin: false
    }
  },
  {
    path: '/checkin',
    component: () => import('../views/login/checkin'),
    meta: {
      title: '申请入驻',
      needLogin: false
    }
  },
  {
    path: '/tiaoz',
    component: () => import('../views/login/tiaoz'),
    meta: {
      title: '跳转中',
      needLogin: false
    }
  },
  {
    path: '/home',
    component: () =>
      import ('../views/home/home'),
    children: homeRouter,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
